import { Orientation } from '@kinopoisk-int/evgen-web-events/web/named_enums';

export const getOrientation = () =>
    window.screen.availWidth > window.screen.availHeight
        ? Orientation.Horizontal
        : Orientation.Vertical;
